// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reportAbuseLink{float:right;display:flex;justify-content:center;align-content:center;flex-direction:column;position:relative}.playerTitleBar .reportAbuseLink{margin-top:3px}.reportAbuseLink a{cursor:pointer}.reportAbuseLink a.reportRoom{padding:2px}.reportAbuseLink a:hover{text-decoration:underline !important}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
